import React from 'react';

import {
  SuitableForFilterValue,
  SuitableForValue,
  SuitableForFilterCount,
} from 'ha/types/SearchFilters';
import { useIntl } from 'ha/i18n';

import CommonCheckboxFilter from './CommonCheckboxFilter';
import CommonCheckboxTitleWithCount from './CommonCheckboxTitleWithCount';

interface Props {
  value: SuitableForFilterValue;
  onChange: (value: SuitableForFilterValue) => void;
  count?: SuitableForFilterCount;
}

const SuitableForFilter: React.FC<Props> = ({ value, onChange, count }) => {
  const { T } = useIntl();

  return (
    <CommonCheckboxFilter
      options={[
        {
          value: SuitableForValue.STUDENTS,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Students')}
              count={count?.students}
            />
          ),
          testLocator: 'SuitableForFilter Students',
        },
        {
          value: SuitableForValue.WORKING_PROFESSIONALS,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Working professionals')}
              count={count?.workingProfessionals}
            />
          ),
          testLocator: 'Filter Working Professionals',
        },
        {
          value: SuitableForValue.COUPLES,
          title: (
            <CommonCheckboxTitleWithCount
              title={T('Couples')}
              count={count?.couples}
            />
          ),
          testLocator: 'Filter Couples',
        },
      ]}
      value={value}
      onChange={onChange}
    />
  );
};

export default SuitableForFilter;
